module.exports = __webpack_public_path__ + "img/dingzhiyansemozhenxingdaiWu.min.c1906294.png";